{
    "Components": {
        "Alert": {
            "ariaLabel": "Schließen",
            "endChatError": "Sitzung konnte nicht beendet werden. Versuche es noch einmal.",
            "sessionEnded": "Deine Sitzung wurde beendet. Du wurdest zur Startseite zurückgeleitet.",
            "networkError": "Beim Herstellen der Verbindung zu deiner Sitzung ist ein Problem aufgetreten. Bitte versuche es später erneut.",
            "messageError": "Sorry, our chat assistant is currently unavailable. Please use <a href='https://ring.com/support'>Ring Help</a> for help resources or try again in a few minutes.",
            "messageLabel": "Alarm"
        },
        "Body": {
            "latestMessage": "Neueste Nachrichten",
            "loadMessages": "Nachrichten laden",
            "newMessage": "Neue Nachricht",
            "title": "Wie können wir dir weiterhelfen?",
            "subtitle": "Hallo! Ich bin der Kundenservice-Assistent von Ring. Wie kann ich dir heute helfen?"
        },
        "Bubble": {
            "ariaLabel": "Chat-Nachricht",
            "sourceTitle": "Hilfreiche Links"
        },
        "Event": {
            "defaultJoin": "Ein Mitglied des Ring-Teams ist dem Live-Chat beigetreten.",
            "customerJoin": "Zum Live-Chat weitergeleitet.",
            "agentJoin": "ist dem Live-Chat beigetreten.",
            "defaultLeft": "Das Teammitglied von Ring hat den Live-Chat verlassen.",
            "customerLeft": "Du hast den Chat verlassen.",
            "agentLeft": "hat den Live-Chat verlassen.",
            "idle": "Du warst eine Weile inaktiv. Lass uns wissen, wenn du Unterstützung brauchst!",
            "idleContinue": "Ich bin noch hier, ich brauche nur mehr Zeit.",
            "idleEnd": "Chat beenden",
            "returned": "Willkommen zurück! Setzen wir das Gespräch fort."
        },
        "FeedbackCard": {
            "ariaLabelThumbsUp": "Gefällt mir",
            "ariaLabelThumbsDown": "Gefällt mir nicht",
            "header": "War das hilfreich?",
            "sent": "Danke für dein Feedback",
            "thumbsDown": "Ich bitte um Entschuldigung dafür, dass meine Antwort nicht zufriedenstellend war. Ich würde mich sehr über ein Feedback von dir freuen, wie ich mich verbessern kann.",
            "thumbsDownResponse": "Danke für dein Feedback. Bitte versuche, deine Frage umzuformulieren.",
            "thumbsUp": "Es freut mich, dass das geholfen hat! Bitte lass mich wissen, wenn ich noch etwas für dich tun kann.",
            "RESPONSE_UNCLEAR": "Antwort unklar",
            "ISSUE_UNRESOLVED": "Mein Problem wurde nicht gelöst",
            "NOT_HELPFUL": "Nicht hilfreich"
        },
        "Footer": {
            "ariaLabel": "Senden",
            "placeholder": "Stelle eine kurze Frage...",
            "subtext": "Dieser Chatbot nutzt generative KI, um deine Fragen zu beantworten. Bitte überprüfe alle wichtigen Informationen in meinen Antworten, bevor du basierend darauf handelst."
        },
        "Header": {
            "ariaLabelMenu": "Menü „Weitere Optionen“",
            "ariaLabelMinimize": "Minimieren",
            "badgeTitle": "BETA",
            "badgeDisabled": "Getrennt",
            "themeLabel": "Thema",
            "muteLabel": "Stumm",
            "unmuteLabel": "Stumm aus",
            "feedbackLabel": "Give Feedback",
            "endLabel": "Chat beenden"
        },
        "NotificationCard": {
            "ariaLabelClose": "Schließen",
            "ariaLabelOpen": "Öffnen",
            "notification": "Neue Nachricht",
            "expand": "Zum Aufklappen klicken"
        },
        "WidgetIcon": {
            "ariaLabel": "Chatten Sie für Unterstützung"
        },
        "WelcomeScreen": {
            "ariaLabel": "Minimieren",
            "button": "Chat starten",
            "title": "Vielen Dank, dass du Ring kontaktiert hast",
            "subtitleHtml": "Wenn du fortfährst, stimmst du den <a href='https://ring.com/terms'>Nutzungsbedingungen von Ring zu.</a> Informationen im Zusammenhang mit diesem Chat können gegebenenfalls gesammelt und aufgezeichnet werden. Weitere Informationen findest du in <a href='https://ring.com/privacy-notice'>unserer Datenschutzerklärung</a>.",
            "loading": "Chat wird gestartet...",
            "error": "Die Sitzung kann nicht gestartet werden. Versuche es noch einmal",
            "messageLabel": "Begrüßungstext"
        }
    }
}
